import { createSlice } from "@reduxjs/toolkit";
import {
  PersonalInformation,
  Promoter,
  RiskProfile,
  RiskProfileQuestionnaire,
  RiskProfileRow,
  TermsOfServiceDocument,
} from "../types/interactiveBrokers";

interface InitialState {
  personalInformation: PersonalInformation | null;
  riskProfileQuestionnaire: RiskProfileQuestionnaire | null;
  riskProfile: RiskProfile | null;
  documentsToAccept: TermsOfServiceDocument[];
  promoters: Promoter[];
  availableRiskProfiles: RiskProfileRow[];
}

const initialState: InitialState = {
  personalInformation: null,
  riskProfileQuestionnaire: null,
  riskProfile: null,
  documentsToAccept: [],
  promoters: [],
  availableRiskProfiles: [],
};

const interactiveBrokersSlice = createSlice({
  name: "interactiveBrokers",
  initialState,
  reducers: {
    onUpdateInteractiveBrokersData: (
      state,
      action: { payload: Partial<InitialState> }
    ) => {
      return { ...state, ...action.payload };
    },
    onResetInteractiveBrokersData: () => {
      return initialState;
    },
  },
});

export const { onUpdateInteractiveBrokersData, onResetInteractiveBrokersData } =
  interactiveBrokersSlice.actions;

export default interactiveBrokersSlice.reducer;
